/**
 * Formats a time in seconds to a human-readable string
 * @param seconds - The time in seconds to format
 * @returns A formatted string in the format "mm:ss"
 */
export const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}; 